import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { checkQuery } from 'src/operations/query';

interface QueryInfo {
  targetId: string;
  query: any;
  targetLabel?: string;
  queryType?: string;
  isValid: boolean;
}

export const useQueryValidation = () => {
  const targets = useSelector((state: any) => state.queryBuilder.targets);

  // Get all queries from all targets
  const allQueries = useMemo(() => {
    if (!targets) return [];

    return Object.entries(targets).map(([targetId, target]) => ({
      targetId,
      query: (target as any)?.target_query,
      targetLabel: (target as any)?.target_label,
      queryType: (target as any)?.query_type,
    }));
  }, [targets]);

  // Verify each query with checkQuery
  const queriesWithValidation = useMemo<QueryInfo[]>(() => {
    return allQueries.map(({ targetId, query, targetLabel, queryType }) => ({
      targetId,
      query,
      targetLabel,
      queryType,
      isValid: checkQuery(query),
    }));
  }, [allQueries]);

  // Overall validation - all queries must be valid
  const isQueryAvailable = useMemo(() => {
    return queriesWithValidation.every(({ isValid }) => isValid);
  }, [queriesWithValidation]);

  return {
    isQueryAvailable,
  };
};
